module.exports = __webpack_public_path__ + "static/media/Code.b700a554.svg";